module.exports = __webpack_public_path__ + "img/center_logo.4e84fc67.png";